import React from 'react';

const MockingContext = React.createContext();

export default MockingContext